import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";


import { Option } from "./options.model";
import { Observable } from "rxjs";
import { StyleManagerService } from "./style-manager.service";

@Injectable()
export class ThemeService {
  constructor(
    private http: HttpClient,private styleManager: StyleManagerService
  ) {}

  getThemeOptions(): Observable<Array<Option>> {
    return this.http.get<Array<Option>>("assets/theme-options.json");
  }

  setTheme(themeToSet) {
    this.styleManager.setStyle(
      "theme",
      `assets/theme-css/${themeToSet}.css`
    );
  }
}
